<a class="avatar avatar-{{size}}" *ngIf="user.ImageUri" title="{{user.FirstName}} {{user.LastName}}">
  <img [src]="user.ImageUri" class="avatar-img rounded-circle border border-white" [alt]="tooltip()">
</a>

<a class="avatar avatar-{{size}}" *ngIf="!user.ImageUri && (user.FirstName || user.LastName)" title="{{user.FirstName}} {{user.LastName}}">
  <span class="avatar-title rounded-circle border border-white" [style.background-color]="getColor().bgColor" >{{getInitials()}}</span>
</a>

<a class="avatar avatar-{{size}}" *ngIf="!user.ImageUri && !user.FirstName && !user.LastName" title="Eingeladen: {{user.EMail}}">
  <img src="assets/img/avatar-placeholder.jpg" class="avatar-img rounded-circle border border-white" alt="tooltip()" />
</a>